import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cCpyDtl from './cCpyDtl';

class iCpyDtl extends cCpyDtl {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stgs ={
  }

  $id_stss = {
  };

  $ilp_loads = () => [
/*
    new Promise( _o_end1 => {
bf.l('31:')
    })
*/
  ];

  $ilp_upds = () => [
  ];

  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={bf.i(global.c?.state.sgc_cm10c410, ['20', '90']) ? true : false}
        rhtPfx={null}
        rhtIconName={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        d_hdrs={{
          pfx: iv._get_hdrPfx('法人情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        n_bdyW={ic.gn_maxBdyW}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm20c310',
              pfx:'会社名',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm20cz10',
              ini: '10',
              pfx:'削除区分　※全体管理者のみ表示',
              ld_iss: [
                {key:'10', pfx: '削除しない'},
                {key:'0', pfx: '削除する'},
              ],
            },
          ],
        }}
      />
    );
  };
};

export default iCpyDtl;
